import { gql } from "@apollo/client";

export const CREATE_MINUTA = gql`
  mutation CreateMinuta($minutaInput: MinutaInput!
  ){
    createMinuta(minutaInput: $minutaInput) {
      success,
      valorEsperado,
      error
    }
}
`;